import React from 'react';
import {Link} from 'react-router-dom';

import ChangePasswordForm from './changePasswordForm/ChangePasswordForm';
import RequestResetPasswordForm from './requestPasswordForm/RequestPasswordForm';

import '../signInForm/signInForm.scss';

export const ResetPasswordForm = ({
  client,
  token,
  changePassword,
  requestPasswordReset,
  checkPasswordResetToken,
  redirectTo,
  clearStatus,
}: any) => {
  return (
    <div className="request-reset-password-form">
      {token ? (
        <>
          <div className="signInTitle">Change password</div>
          <ChangePasswordForm
            client={client}
            token={token}
            changePassword={changePassword}
            checkPasswordResetToken={checkPasswordResetToken}
            redirectTo={redirectTo}
          />
        </>
      ) : (
        <>
          <div className="signInTitle">Reset password</div>
          <div className="signInSubtitle">
            Remember your password?{' '}
            <Link style={{padding: '0px'}} to="/login" onClick={() => clearStatus()}>
              Log in
            </Link>
          </div>
          <RequestResetPasswordForm
            client={client}
            requestPasswordReset={requestPasswordReset}
            redirectTo={redirectTo}
          />
        </>
      )}
    </div>
  );
};
